<div class="page">
    <div class="page-body" *ngIf="response.status == 1">
        <div class="page-title" *ngIf="page.mostrar_titulo">
            <div class="container"> 
                <h1 class="wow slideInDown" data-wow-delay="0.7s">{{page.titulo}}</h1>
                <h2 *ngIf="page.mostrar_subtitulo">{{page.subtitulo}}</h2>
            </div>    
        </div>
        <div class="page-content">
            <section class="section section-descricao" *ngIf="page.mostrar_texto">
                <div class="container"> 
                    <article [innerHtml]="page.texto | safeHtml"></article> 
                </div>    
            </section>
            <section class="section section-form">
                <div class="container"> 
                    <form class="form" autocomplete="off" (submit)="enviar()">
                        <div class="row">
                            <div class="col-md-6">
                                <div class="row">
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label>Nome: </label>
                                            <input type="text" [(ngModel)]="dataItem.nome" name="nome" class="form-control" />
                                        </div>
                                    </div> 
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label>E-mail: </label>
                                            <input type="text" [(ngModel)]="dataItem.email" name="email" class="form-control" />
                                        </div>
                                    </div>  
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label>Telefone: </label>
                                            <input type="text" [(ngModel)]="dataItem.telefone" name="telefone" class="form-control" phoneMask />
                                        </div>
                                    </div> 
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label>Assunto: </label>
                                            <input type="text" [(ngModel)]="dataItem.assunto" name="assunto" class="form-control" phoneMask />
                                        </div>
                                    </div>   
                                </div>
                                <div class="form-group">
                                    <label>Mensagem: </label>
                                    <textarea [(ngModel)]="dataItem.mensagem" name="mensagem" class="form-control"></textarea>
                                </div>
                                <div class="footer">  
                                    <button type="submit" class="btn-two">
                                        ENVIAR
                                    </button>  
                                </div>  
                            </div>
                            <div class="col-md-6">
                                <div class="contatos">
                                    <modulo posicao="contato" template="page-contato"></modulo>
                                </div>
                            </div>
                        </div>     
                    </form> 
                </div>       
            </section>
            <section class="section section-map">
                <div class="section-title">
                    <div class="container">
                        <h2>Já conhece a nossa casa ?</h2>
                        <h3>Venha nos visitar :)</h3>
                    </div>    
                </div>    
                <div class="section-content">
                    <iframe [src]="linkMap" width="100%" height="450" style="border:0;" allowfullscreen="" loading="lazy"></iframe>
                </div>
            </section>
        </div>
    </div>
    <div class="page-body" *ngIf="response.status == 500">
        <page-error (reload)="getData()"></page-error>   
    </div>    
</div>         
<loader [hidden]="!loader" [message]="message"></loader> 